function ShopTimeOverlay() {
    return {
        restrict: 'E',
        scope: {
            store: '='
        },
        template: require('./shop-time-overlay.html')
    };
}

module.exports = ShopTimeOverlay;


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/shoplocator/shop-time-overlay.js
 **/